export var modelStyleProps = function modelStyleProps() {
  var propertiesFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clubId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mlb';
  var _propertiesFile$prope = propertiesFile.properties,
    properties = _propertiesFile$prope === void 0 ? {} : _propertiesFile$prope,
    _propertiesFile$palet = propertiesFile.palette,
    palette = _propertiesFile$palet === void 0 ? {} : _propertiesFile$palet;
  var urlLogo = properties.urlLogo;
  urlLogo = urlLogo && urlLogo.url;
  var defaultUrlLogo = clubId !== 'mlb' ? "//www.mlbstatic.com/team-logos/url/".concat(clubId, ".svg") : undefined;
  return {
    urlLogo: urlLogo || defaultUrlLogo,
    theme: palette
  };
};
export var __test = {
  modelStyleProps: modelStyleProps
};